module.exports = __webpack_public_path__ + "img/04ed9ad75b40f83b2141c95fcf6b8b10.png";